exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-5fde376a] {\n  text-align: left;\n}\n", ""]);

// exports
